<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1,1,1)" label-width="80px">
            <el-form-item label="关键字" prop="keyword">
                <el-input v-model.trim="searchForm.keyword" maxlength="20"
                          placeholder="请输入关键字(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="标注时间" prop="createTime">
                <el-date-picker
                        v-model="searchForm.createTime"
                        clearable
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="标注状态" prop="labeState">
                <el-select v-model="searchForm.labeState" style="width: 100%" placeholder="请选择标注状态"
                           clearable>
                    <el-option
                            v-for="item in $dictUtils.getDictList('labe_state')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询
                </el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="p_all1">
            <el-button v-if="hasPermission('converge:mark:myMark:submit')" type="primary"
                       @click="submitData()"
                       size="small">批量提交
            </el-button>
            <el-button v-if="hasPermission('converge:mark:myMark:export')" type="primary"
                       @click="exportData()"
                       size="small">批量导出
            </el-button>
            <el-button v-if="hasPermission('converge:mark:myMark:delete')"
                       @click="deleteData()"
                       size="small">批量删除
            </el-button>
        </div>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small" height="100%"
                class="table" border
                ref="multipleTable"
                :row-key="'id'"
                @sort-change="sortChangeHandle"
                @selection-change="selectionChangeHandle"
        >
            <el-table-column :reserve-selection="true" type="selection" width="50"/>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="labelName" label="标注名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createDate" sortable label="标注时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="labeState" label="标注状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $dictUtils.getDictLabel("labe_state", scope.row.labeState, '') }}
                </template>
            </el-table-column>
            <el-table-column prop="resourcesName" label="标注资源" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <el-link type="primary" @click="view(row)">{{ row.resourcesName }}</el-link>
                </template>
            </el-table-column>
            <el-table-column fixed="right" min-width="80px" label="操作">
                <template slot-scope="{row}">
                    <el-button v-if="hasPermission(`converge:mark:myMark:edit`)"
                               type="text" size="small"
                               v-show="row.labeState == 0 || row.labeState == 3 || row.labeState == 4"
                               @click="editData('edit',row)">编辑
                    </el-button>
                    <el-button v-if="hasPermission(`converge:mark:myMark:submit`)"
                               type="text" size="small"
                               v-show="row.labeState == 0 || row.labeState == 3 || row.labeState == 4"
                               @click="submitData(row)">重新提交
                    </el-button>
                    <el-button v-if="hasPermission(`converge:mark:myMark:delete`)"
                               type="text" size="small"
                               v-show="row.labeState != 1 && row.labeState != 2"
                               @click="deleteData(row)">删除
                    </el-button>
                    <el-button v-if="hasPermission('converge:mark:myMark:record')" type="text" size="small"
                               @click="recordData(row)">审核记录
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <edit-mark ref="editMark" @refresh="refreshList(1,1,1)"></edit-mark>
        <resource-add-edit-form ref="resourceAddEditForm" @refreshData="refreshList(1,1)"></resource-add-edit-form>
        <audit-records ref="auditRecords"></audit-records>
    </div>
</template>

<script>
import editMark from "@/views/modules/converge/mark/editMark.vue";
import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";
import AuditRecords from "@/components/toExamine/auditRecords.vue";


export default {
    name: "myMark",
    components: {AuditRecords, ResourceAddEditForm, editMark},
    data() {
        return {
            searchForm: {
                keyword: '',
                createTime: [],
                createStartDate: '',
                createEndDate: '',
                labeState: '',
                orderBy: "",
                current: 1,
                size: 20,
            },
            total: 0,

            loading: false,
            dataList: [],
            dataListSelect: [],

            searchData: {},
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect, sort) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (sort) {
                this.$refs.multipleTable.clearSort()
            }
            this.loading = true
            if (this.searchForm.createTime && this.searchForm.createTime.length != 0) {
                this.searchForm.createStartDate = this.searchForm.createTime[0]
                this.searchForm.createEndDate = this.searchForm.createTime[1]
            } else {
                this.searchForm.createStartDate = ''
                this.searchForm.createEndDate = ''
            }
            this.searchData = this.searchForm

            let searchData = JSON.parse(JSON.stringify(this.searchForm))
            this.$delete(searchData,'createTime')
            this.$axios(this.api.academic.resourceslabelList, searchData).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1, 1)
        },
        //排序
        sortChangeHandle(obj) {
            obj.prop = this.getHumpLineName(obj.prop);
            if (obj.order === 'ascending') {
                this.searchForm.orderBy = obj.prop + ' asc'
            } else if (obj.order === 'descending') {
                this.searchForm.orderBy = obj.prop + ' desc'
            } else {
                this.searchForm.orderBy = ''
            }
            this.refreshList(1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //type add新增 edit编辑
        editData(type, row) {
            this.$refs.editMark.init(type, row)
        },

        //详情 typeName view详情 edit编辑 toExamineView审核详情
        view(row) {
            this.$refs.resourceAddEditForm.init('view', row.resourcesId, '', row.basicDataId,'',row)
        },

        //提交
        submitData(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let ids = []
            let noSubmit = []
            let cs = []
            list.forEach(item => {
                cs.push(
                    {
                        id:item.id,
                        basicDataId:item.basicDataId,
                        resourcesId:item.resourcesId
                    }
                )
                ids.push(item.id)
                if (item.labeState != 0 && item.labeState != 3 && item.labeState != 4) {
                    noSubmit.push(item)
                }
            })
            if (noSubmit.length != 0) {
                this.$message.warning('只能选择待提交和已驳回的数据提交')
                return
            }
            console.log(cs)
            this.$confirm(`提交后将审核资源标注`, '确认提交资源标注吗？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.resourceslabelSubmit, cs, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('提交成功')
                        this.refreshList('', 1)
                        //更新我的未读信息
                        this.$store.commit('user/updateUserMessage')
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        //导出
        exportData() {
            if (this.dataListSelect.length == 0) {
                if (this.total == 0) {
                    this.$message.warning('暂无可导出的数据!')
                    return
                }
                if (this.total > 20000) {
                    this.$message.warning('单次最多导出2万条数据！')
                    return
                }
            } else {
                if (this.dataListSelect.length > 20000) {
                    this.$message.warning('单次最多导出2万条数据！')
                    return
                }
            }
            let ids = this.dataListSelect.map(item => {
                return item.middleId
            })
            this.exportExcel(this.api.academic.resourceslabelExport, {
                ids,
                ...this.searchData
            }, '我的标注信息', 'post')
        },

        //审核记录
        recordData(row){
            this.$refs.auditRecords.init(row.id)
        },

        //删除
        deleteData(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let noDelete = []
            let ids = list.map(item => {
                if (item.labeState == 1 || item.labeState == 2) {
                    noDelete.push(item)
                }
                return item.middleId
            })
            if (noDelete.length != 0) {
                this.$message.warning('已通过、审核中的数据不支持删除')
                return
            }
            this.$confirm(`删除后数据不可恢复，是否继续？`, '删除所选数据？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.resourceslabelRemoveById, {ids}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    }
}
</script>

<style scoped>

</style>
